<template>
	<v-dialog v-if="dialog" v-model="dialog" width="530" persistent>
		<v-card>
			<v-card-title> Requirement list </v-card-title>
			<v-card-text class="pt-1">
				<v-form @submit.prevent="addRequirement">
					<div class="d-flex align-center">
						<v-text-field
							v-model="requirement" outlined dense hide-details
							placeholder="Requirement (Ex. Credentials, VPN, etc.)"
						/>
						<v-btn type="submit" color="primary" class="ml-3" :disabled="!requirement">Add</v-btn>
					</div>
				</v-form>
				<div class="mt-2">
					<v-chip v-for="(req, ix) in requirements" :key="ix" outlined color="primary" class="mr-2 mb-2">
						{{req.name}}
						<v-icon @click="removeRequirement(ix)" class="cursor-pointer" right>mdi-close-circle</v-icon>
					</v-chip>
				</div>
      </v-card-text>
			<v-card-actions class="justify-end">
				<v-btn @click="close(false)" color="primary" outlined>Cancel</v-btn>
				<v-btn @click="save" color="primary">Confirm</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>	
</template>

<script>
export default {
	data: () => ({
		dialog: false,
		id: null,
		requirements: [],
		resolve: null,
		requirement: '',
	}),
	methods: {
		open(id){
			this.id = id
			this.dialog = true
			this.$http.get(`api/nucleiManagement/${id}/requirements`)
				.then(res => {
					this.requirements = res.data
				})
				.catch(err => {
					console.error(err)
					this.$root.error('Cannot load data')
				})

			return new Promise(res => {
				this.resolve = res
			})
		},
		save(){
			this.$http.post(`api/nucleiManagement/${this.id}/requirements`, this.requirements)
				.then(() => {
					this.close(true)
					this.$root.success('Requirements saved successfully')
				})
				.catch(err => {
					console.error(err)
					this.$root.error('Cannot save changes')
				})
		},
		addRequirement(){
			if(!this.requirement) return
			this.requirements.push({
				name: this.requirement
			})
			this.requirement = ''
		},
		removeRequirement(index){
			this.requirements = this.requirements.filter((r, ix) => ix != index)
		},
		close(val){
			this.requirement = ''
			this.dialog = false
			this.resolve(val)
		},
	},
}
</script>

<style lang="scss" scoped>

</style>